import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import AutoSuggest from 'react-autosuggest'

interface IComponentProps {
  bsSize?: string
  clearInputAfterSelection?: boolean
  dataSource: any
  labelKey?: string
  maxResults?: number
  name?: string
  onChange: (e: any) => void
  placeholder?: string
  required?: boolean
  value?: any
  _onSuggestionFetchRequested?: (value: any) => any
  _renderSuggestion?: (suggestion: any) => any
}

interface IComponentState {
  suggestions: any
  filter: string
  value: string
}

export default class TypeAheadList extends React.PureComponent<
  IComponentProps,
  IComponentState
> {
  private timeoutId: any

  constructor(props: any) {
    super(props)

    bindFunctions(this)

    this.state = {
      filter: this.props.value || '',
      suggestions: [],
      value: '',
    }
  }

  public render() {
    const theme: any = {
      container: {
        position: 'relative',
      },
      input: {},
      inputFocused: {
        outline: 'none',
      },
      inputOpen: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
      suggestion: {
        cursor: 'pointer',
        padding: '10px 20px',
      },
      suggestionHighlighted: {
        backgroundColor: '#ddd',
      },
      suggestionsContainer: {
        display: 'none',
      },
      suggestionsContainerOpen: {
        backgroundColor: '#fff',
        border: '1px solid #aaa',
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        display: 'block',
        fontFamily: 'Helvetica, sans-serif',
        fontSize: 16,
        fontWeight: 300,
        position: 'absolute',
        top: 51,
        width: '100%',
        zIndex: 2,
      },
      suggestionsList: {
        listStyleType: 'none',
        margin: 0,
        padding: 0,
      },
    }

    const className = `form-control ${
      this.props.bsSize ? `form-control-${this.props.bsSize}` : ''
    }`

    const inputProps = {
      autoComplete: 'nope',
      className,
      name: this.props.name,
      onChange: (e: any, d: any) => this.handleChange(e, d),
      placeholder: this.props.placeholder || 'Start typing to filter...',
      required: this.props.required,
      value: this.state.filter,
    }

    return (
      <AutoSuggest
        suggestions={
          this.state.suggestions.length > 0
            ? this.state.suggestions
            : [this.props.dataSource]
        }
        inputProps={inputProps}
        getSuggestionValue={this.getSuggestionValue}
        onSuggestionSelected={(e, { suggestion }) =>
          this.props.onChange(suggestion)
        }
        onSuggestionsFetchRequested={
          this.props._onSuggestionFetchRequested ||
          this.onSuggestionsFetchRequested
        }
        renderSuggestion={this.props._renderSuggestion || this.renderSuggestion}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        theme={theme}
      />
    )
  }

  private onSuggestionsClearRequested = () => {
    if (this.props.clearInputAfterSelection) {
      this.setState({
        filter: '',
        suggestions: [],
        value: '',
      })
    } else {
      this.setState({
        suggestions: [],
        value: '',
      })
    }
  }

  private getSuggestionValue = (suggestion: any) => {
    if (this.props.labelKey) {
      return suggestion[this.props.labelKey].trim()
    }

    return suggestion.name.trim()
  }

  private renderSuggestion = (suggestion: any) => {
    return (
      <div>
        <div>
          <div>{suggestion.name}</div>
        </div>
      </div>
    )
  }

  private getSuggestions = (suggestion: any) => {
    const inputValue = suggestion.value.trim().toLowerCase()
    const inputLength = inputValue.length

    return inputLength === 0
      ? []
      : this.props.dataSource.filter(
          (item: any) => item.name.toLowerCase().indexOf(inputValue) >= 0,
        )
  }

  private onSuggestionsFetchRequested = (value: any) => {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }

    this.timeoutId = setTimeout(() => {
      this.setState({
        suggestions: this.getSuggestions(value),
      })
    }, 250)
  }

  private handleChange(event: any, item: any) {
    this.setState({
      filter: item.newValue,
      value: item.newValue,
    })
  }
}
